export default "__VITE_ASSET__BSP3qzgd__"